module.exports = __webpack_public_path__ + "static/footerbg-3bb50408d8e1aa12720b20119b664dc7.png";